<template>
  <div class="sticky-top">
    <ul
      v-if="countyInfoBannerText"
      class="alert alert-warning text-center text-black list-unstyled mb-0 p-2"
    >
      <li class="fw-bold fs-6" v-html="countyInfoBannerText" />
    </ul>
    <div v-if="EFormsAlert">
      <div class="alert alert-danger shadow fw-bold fs-6" role="alert">
        E-Forms are not available for this property.
      </div>
    </div>
  </div>
</template>
<style scoped>
ul {
  padding: 0.5rem 1rem 0.5rem 2rem;
  margin-bottom: 0;
}
</style>
<script>
import sanitizeHtml from "sanitize-html";

export default {
  computed: {
    countyInfoBannerText() {
      let bannerText = this.infoBannerText;
      if (bannerText) {
        bannerText = bannerText.replace(/\\n\\n/g, "\\n"); // no double spacing!
        bannerText = bannerText.replace(/\\n/g, "<br>"); // replace all \n with <br>
        return sanitizeHtml(bannerText, {
          allowedTags: [
            "a",
            "abbr",
            "address",
            "b",
            "blockquote",
            "br",
            "cite",
            "dd",
            "dl",
            "dt",
            "em",
            "hr",
            "i",
            "li",
            "mark",
            "ol",
            "p",
            "pre",
            "small",
            "span",
            "strong",
            "sub",
            "sup",
            "time",
            "u",
            "ul",
          ],
          disallowedTagsMode: "discard",
          allowedAttributes: {
            a: ["href", "name", "target"],
          },
          selfClosing: ["br", "hr"],
          allowedSchemesByTag: { a: ["http", "https", "mailto", "tel"] },
          allowedSchemesAppliedToAttributes: ["href"],
        });
      } else {
        return null;
      }
    },
  },
  props: {
    county: {
      type: Object,
      required: true,
    },
    currentPayYear: {
      type: String,
      required: true,
    },
    infoBannerText: {
      type: String,
      required: false,
    },
    EFormsAlert: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
